import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Form,
} from "reactstrap";
import SideBar from "../../../components/sidebar/Sidebar";
import UserBase from "../../../components/user/UserBase";
import {
  fetchNetWorth,
  getBeneficiary,
  getOwnerByUserId,
  getSecondaryUser,
  getToken,
  getTrustByUserId,
  getUser
} from "../../../services/user-service";
//import { useState } from 'react'
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Option, Select, Textarea } from "@mui/joy";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SharedBeneficiaryEdit from "../../../components/SharedBeneficiaryEdit";
import "../../../css/formPOPup.css";
import "../../../css/myestate_edit.css";
import {
  getSinglejewelry,
  updateJewelries,
} from "../../../services/JewelryService";
import { getCachedGoldPrice } from "../GoldPrice";
import { getCachedSilverPrice } from "../SilverPrice";
import { getCachedPalladiumPrice } from "../PalladiumPrice";

function EditJewelry() {
  const { id } = useParams();
  const navigate = useNavigate();
  // }
  const [data, setData] = useState({
    jewelry: {
      owner: "",
      jewelryCaption: "",
      jewelryName: "",
      otherJewelryName: "",
      quantity: "",
      perQuantityValue: "",
      estimatedValue: "",
      caratValue: "",
      weight: "",
      trust: "",
      beneficiaryName: "",
      notes: "",
    },
    sharedDetails: [
      {
        distributedType: "",
        distributedValue: "",
        distributedAmount: "",
        beneficiaryId: "",
      },
    ],
  });

  // for owner field
  const [ownerName, setOwnerName] = useState([]);
  const handleChange = (event, newValue, stringValue) => {
    if (stringValue === "caratValue") {
      setData((prevData) => ({
        ...prevData,
        jewelry: {
          ...prevData.jewelry,
          caratValue: newValue,
        },
      }));
    }

    if (stringValue === "jewelryName") {
      setData((prevData) => ({
        ...prevData,
        jewelry: {
          ...prevData.jewelry,
          jewelryName: newValue,
        },
      }));
    }

    if (stringValue === "owner") {
      // Convert ownerName array to a single string

      const comingValue =
        typeof newValue === "string" ? newValue.split(",") : newValue;
      const ownerString = comingValue.join(", ");

      setData((prevData) => ({
        ...prevData,
        jewelry: {
          ...prevData.jewelry,
          owner: ownerString,
        },
      }));

      // Update the ownerName state afterwards
      setOwnerName(newValue);
    }
  };

  // Define an array to store user names
  const [ownerNames, setOwnerNames] = useState([]);

  // Get primaryUser data
  const primaryUserDetails = getUser();
  const primaryUserName =
    primaryUserDetails.firstName + " " + primaryUserDetails.lastName;

  // Get secondaryUser data
  const secondaryUserDetails = getSecondaryUser();

  useEffect(() => {
    const fetchOwnerData = async () => {
      const userId = getUser().commonId;
      const token = "Bearer " + getToken();

      try {
        const resp = await getOwnerByUserId(token, userId);
        // Process data after fetching
        const names = [primaryUserName];

        // Check if secondary user exists
        if (secondaryUserDetails !== undefined) {
          const secondaryUserName = `${secondaryUserDetails.firstName} ${secondaryUserDetails.lastName}`;
          names.push(secondaryUserName);
        }
        resp.forEach((user) => {
          const fullName = `${user.firstName} ${user.lastName}`;
          names.push(fullName);
        });

        // Update ownerNames state
        setOwnerNames(names);
      } catch  {
        toast.error("Failed to fetch owner data");
      }
    };

    fetchOwnerData();
  }, []);

  // use state to set the selected images
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedImage1, setSelectedImage1] = useState([]);

  // Handle image
  const handleImageChange = (event) => {
    const selectedFiles = event.target.files;
    const allowedExtensions = ["pdf"];
    const maxFileSize = 4 * 1024 * 1024; // 4 MB

    if (selectedFiles) {
      const selectedFilesArray = Array.from(selectedFiles);

      const invalidFiles = selectedFilesArray.filter((file) => {
        const fileNameParts = file.name.split(".");
        const fileExtension =
          fileNameParts[fileNameParts.length - 1].toLowerCase();
        const isInvalidExtension = !allowedExtensions.includes(fileExtension);
        const isTooLarge = file.size > maxFileSize;
        return isInvalidExtension || isTooLarge;
      });

      if (invalidFiles.length === 0) {
        const formData = new FormData();
        selectedFilesArray.forEach((file, index) => {
          formData.append(`file${index + 1}`, file);
        });
        setSelectedImage(selectedFilesArray);
      } else {
        toast.error("Please upload a valid PDF under 4 MB.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        event.target.value = "";
      }
    }
  };




  // const handleChanges = (event, property) => {
  //   setData({ ...data, [property]: event.target.value });
  // };

  useEffect(() => {
    if (data.jewelry.jewelryName !== "Other") {
      setData((prevData) => ({
        ...prevData,
        jewelry: {
          ...prevData.jewelry,
          otherJewelryName: "",
        },
      }));
    }
  }, [data.jewelry.jewelryName]);

  const [sharedType, setSharedType] = useState(null);
  const handleChanges = async (e, field) => {
    const value = e?.target?.value ?? e?.value ?? e ?? "";

    if (field === "sharedType") {
      setSharedType(value);
      setData((prevData) => ({
        ...prevData,
        sharedDetails: [
          {
            distributedType: "",
            distributedValue: "",
            distributedAmount: "",
            beneficiaryId: "",
          },
        ],
        jewelry: {
          ...prevData.jewelry,
          trust: "",
          beneficiaryName: "",
        },
      }));
      return;
    }

    const updatedJewelry = {
      ...data.jewelry,
      [field]: value,
    };

    setData((prev) => ({
      ...prev,
      jewelry: updatedJewelry,
    }));

    const name = updatedJewelry?.jewelryName?.toLowerCase() || "";
    const caratValue = updatedJewelry?.caratValue || "";
    const weight = parseFloat(updatedJewelry?.weight || 0);
    const quantity = parseFloat(updatedJewelry?.quantity || 0);
    const unit = updatedJewelry?.unit || "gm";
    const convertedWeight = unit === "oz" ? weight * 31.1035 : weight;

    // ---- GOLD ----
    if (name === "gold" && caratValue) {
      try {
        const prices = await getCachedGoldPrice();
        const caratFormatted = `${caratValue}K`;
        const pricePerGram = parseFloat(prices[caratFormatted]?.perGram || 0);

        const perValueRaw = pricePerGram * convertedWeight;
        const estValueRaw = perValueRaw * (quantity || 1);

        const perValue = isNaN(perValueRaw)
          ? 0
          : (Math.round(perValueRaw * 100) / 100).toFixed(2);
        const estValue = isNaN(estValueRaw)
          ? 0
          : (Math.round(estValueRaw * 100) / 100).toFixed(2);

        setData((prev) => ({
          ...prev,
          jewelry: {
            ...updatedJewelry,
            perQuantityValue: perValue,
            estimatedValue: estValue,
          },
        }));

        setEstimatedTotalAmount(estValue);
      } catch (err) {
        toast.error("Failed to fetch gold price.");
      }
      return;
    }

    // ---- SILVER ----
    if (name === "silver" && caratValue) {
      try {
        const pricePerGram = await getCachedSilverPrice();
        const purity = parseFloat(caratValue);

        const perValueRaw = pricePerGram * purity * convertedWeight;
        const estValueRaw = perValueRaw * (quantity || 1);

        const perValue = (Math.round(perValueRaw * 100) / 100).toFixed(2);
        const estValue = (Math.round(estValueRaw * 100) / 100).toFixed(2);

        setData((prev) => ({
          ...prev,
          jewelry: {
            ...updatedJewelry,
            perQuantityValue: perValue,
            estimatedValue: estValue,
          },
        }));

        setEstimatedTotalAmount(estValue);
      } catch (err) {
        toast.error("Failed to fetch silver price.");
      }
      return;
    }

    // ---- PALLADIUM ----
    if (name === "palladium" && caratValue) {
      try {
        const pricePerGram = await getCachedPalladiumPrice();
        const purity = parseFloat(caratValue);

        const perValueRaw = pricePerGram * purity * convertedWeight;
        const estValueRaw = perValueRaw * (quantity || 1);

        const perValue = (Math.round(perValueRaw * 100) / 100).toFixed(2);
        const estValue = (Math.round(estValueRaw * 100) / 100).toFixed(2);

        setData((prev) => ({
          ...prev,
          jewelry: {
            ...updatedJewelry,
            perQuantityValue: perValue,
            estimatedValue: estValue,
          },
        }));

        setEstimatedTotalAmount(estValue);
      } catch (err) {
        toast.error("Failed to fetch palladium price.");
      }
      return;
    }

    // ---- QUANTITY / VALUE ----
    if (field === "quantity" || field === "perQuantityValue") {
      const quantityVal =
        field === "quantity" ? value : data.jewelry.quantity || 0;
      const perValueVal =
        field === "perQuantityValue"
          ? value
          : data.jewelry.perQuantityValue || 0;
      const estimated = parseFloat(quantityVal) * parseFloat(perValueVal);

      setData((prev) => ({
        ...prev,
        jewelry: {
          ...prev.jewelry,
          [field]: value,
          estimatedValue: estimated,
        },
      }));
      setEstimatedTotalAmount(estimated);
      return;
    }

    // ---- DEFAULT UPDATE ----
    setData((prev) => ({
      ...prev,
      jewelry: {
        ...prev.jewelry,
        [field]: value,
      },
    }));
  };


  // post the form
  const jewelryForm = (event) => {
    event.preventDefault();
    let token = "Bearer " + getToken();
    const formData = new FormData();

    if (null != selectedImage) {
      for (let i = 0; i < selectedImage.length; i++) {
        formData.append(`files`, selectedImage[i]);
       }
    }

    for (let i = 0; i < selectedImage1.length; i++) {
      formData.append(`imageFiles`, selectedImage1[i]);
     }

    formData.append("data", JSON.stringify(data));

    updateJewelries(formData, token)
      .then((resp) => {
        toast.success("Updated Successfully!!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        fetchNetWorth(primaryUserDetails.commonId);
        navigate("/user/my-estate/jewelry");
      })
      .catch((error) => {
         toast.error("An error occurred. Please try again.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      });
  };

  const [responseData, setResponseData] = useState(null);
  const [responseAssetData, setResponseAssetData] = useState(null);
  const getData = () => {
    let token = "Bearer " + getToken();
    getSinglejewelry(token, id).then((res) => {
      setData({
        ...data,
        jewelry: res.jewelry,
        documents: res.documents,
        sharedDetails: res.sharedDetails,
        supportingImages: res.supportingImages,
      });
      setResponseData(res);
      setResponseAssetData(res?.jewelry);
      const ownerNameArray = res.jewelry.owner.split(", ");

      setOwnerName(ownerNameArray);
      if (res.jewelry.trust !== "" && res.jewelry.trust != null) {
        setSharedType("Trust");
      } else if (
        res.jewelry.beneficiaryName !== "" &&
        res.jewelry.beneficiaryName != null
      ) {
        setSharedType("Beneficiary");
      } else {
        setSharedType(null);
      }
      setEstimatedTotalAmount(res.jewelry.estimatedValue);
    });
  };

  useEffect(() => {
    getData();
    getBenificiarydata();
    getTrustsData();
  }, []);

  // beneficiary addition in form
  const [beneficiary, setBenificiary] = useState([]);
  const getBenificiarydata = () => {
    let userId = getUser().commonId;
     let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => console.log(err));
  };

  //
  const [benevisible, setbeneVisible] = useState(false);
  const [estimatedTotalAmount, setEstimatedTotalAmount] = useState(0);

  const handleShowBeneficiary = () => {
    setbeneVisible(true);
    setEstimatedTotalAmount(data.jewelry.estimatedValue);
  };

  const handleEditCloseBeneficiary = (params) => {
    const { name } = params;
    if (name !== undefined) {
      setData((prevData) => ({
        ...prevData,
        sharedDetails: name,
      }));
    }
    setbeneVisible(false);
  };
const getColumnTitleForJewelry = (type) => {
  switch (type) {
    case "Gold":
      return "Carat*";
    case "Silver":
      return "Purity*";
    case "Platinum":
    case "Palladium":
      return "Purity (%)*";
    case "Stone":
      return "Quality Grade*";
    case "Other":
      return "Detail*";
    default:
      return "Carat/Purity*";
  }
};
const getPlaceholderForJewelry = (type) => {
  switch (type) {
    case "Gold":
      return "Select Carat";
    case "Silver":
      return "Select Purity";
    case "Platinum":
    case "Palladium":
      return "Select Purity (%)";
    case "Stone":
      return "Select Grade";
    case "Other":
      return "Enter Detail";
    default:
      return "Select Value";
  }
};
  const [trusts, setTrusts] = useState([]);
  const getTrustsData = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getTrustByUserId(token, userId)
      .then((res) => {
        setTrusts(res);
      })
      .catch((err) => {});
  };
  const handleTrustSave = () => {
    setbeneVisible(false);
  };

  return (
    <UserBase>
      <div className="mt-5"></div>
      <SideBar>
        <div className="overlay1" style={{ transition: "500ms", height: "" }}>
          <div>
            <Form onSubmit={jewelryForm} className="addform_body">
              <container>
                <div className="homepage jewelry_container">
                  <Card>
                    <CardHeader>
                      <div
                        style={{ width: "100%" }}
                        className="addform_heading"
                      >
                        <h3 className="addform_heading_h1">
                          {data.jewelry.jewelryListName}
                        </h3>
                        <div className="addform_close">
                          <FontAwesomeIcon
                            icon={faXmark}
                            onClick={() => {
                              navigate("/user/my-estate/jewelry");
                            }}
                          />
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody className="jewelry_card_body">
                      <div>
                        <table className="jewelry_table">
                          <thead>
                            <tr>
                              <th className="jewelry_130px">Select Owner*</th>
                              <th className="jewelry_110px">Metal Type*</th>
                              <th className="jewelry_130px">Metal Name*</th>
                              <th className="jewelry_90px">
                                {getColumnTitleForJewelry(data.jewelry.jewelryName)}
                              </th>
                              <th className="jewelry_100px">Weight (gram / ounce)*</th>
                              <th className="jewelry_90px">Quantity*</th>
                              <th className="jewelry_90px">Qty/Value*</th>
                              <th className="jewelry_130px">Appraised Val*</th>
                              <th>Documents</th>
                              <th>Beneficiary*</th>
                              <th>Notes</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <Select
                                  className="jewelry_select jewelry_130px"
                                  placeholder="Select Owner"
                                  value={ownerName}
                                  multiple
                                  onChange={(event, newValue) =>
                                    handleChange(event, newValue, "owner")
                                  }
                                  sx={{ minWidth: "13rem" }}
                                  slotProps={{
                                    listbox: {
                                      sx: { width: "100%" },
                                    },
                                  }}
                                  required
                                >
                                  {ownerNames.map((name) => (
                                    <Option key={name} value={name}>
                                      {name}
                                    </Option>
                                  ))}
                                </Select>
                              </td>

                              <td>
                                <div className="jewelry_select_and_input">
                                  <div>
                                    <Select
                                      className="jewelry_select jewelry_110px"
                                      value={data.jewelry.jewelryName}
                                      onChange={(event, newValue) =>
                                        handleChange(
                                          event,
                                          newValue,
                                          "jewelryName"
                                        )
                                      }
                                      required
                                    >
                                      <Option value="">Metal Type</Option>
                                      <Option value="Gold">Gold</Option>
                                      <Option value="Silver">Silver</Option>
                                      {/* <Option value="Platinum">Platinum</Option> */}
                                      <Option value="Palladium">
                                        Palladium
                                      </Option>
                                      {/* <Option value="Stone">Stone</Option> */}
                                      <Option value="Other">Other</Option>
                                    </Select>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <Input
                                  className="jewelry_input jewelry_130px"
                                  placeholder="Metal Name"
                                  onChange={(e) =>
                                    handleChanges(e, "jewelryCaption")
                                  }
                                  value={data.jewelry.jewelryCaption}
                                />
                              </td>
                              <td>
                                {(() => {
                                  const type = data.jewelry.jewelryName;

                                  if (type === "Gold") {
                                    return (
                                      <Select
                                        className="jewelry_select jewelry_90px"
                                        placeholder={getPlaceholderForJewelry(type)}
                                        value={data.jewelry.caratValue || ""}
                                        onChange={(e, newValue) =>
                                          handleChanges(newValue, "caratValue")
                                        }
                                        required
                                      >
                                        <Option value="">Select</Option>
                                        <Option value="24">24K</Option>
                                        <Option value="22">22K</Option>
                                        <Option value="20">20K</Option>
                                        <Option value="18">18K</Option>
                                        <Option value="16">16K</Option>
                                        <Option value="14">14K</Option>
                                      </Select>
                                    );
                                  } else if (type === "Silver") {
                                    return (
                                      <Select
                                        className="jewelry_select jewelry_130px"
                                        placeholder={getPlaceholderForJewelry(type)}
                                        value={data.jewelry.caratValue || ""}
                                        onChange={(e, newValue) => handleChanges(newValue, "caratValue")}
                                        required
                                      >
                                        <Option value="">Select Purity</Option>
                                        <Option value="0.999">Fine Silver (99.9%)</Option>
                                        <Option value="0.925">Sterling Silver (92.5%)</Option>
                                        <Option value="0.9">Coin Silver (90%)</Option>
                                      </Select>
                                    );
                                  } else if (type === "Platinum" || type === "Palladium") {
                                    return (
                                      <Select
                                        className="jewelry_select jewelry_130px"
                                        placeholder={getPlaceholderForJewelry(type)}
                                        value={data.jewelry.caratValue || ""}
                                        onChange={(event, newValue) =>handleChanges(newValue, "caratValue")}
                                        required
                                      >
                                        <Option value="">Select Purity</Option>
                                        <Option value="0.999">99.9%</Option>
                                        <Option value="0.95">95%</Option>
                                      </Select>
                                    );
                                  } else if (type === "Stone") {
                                    return (
                                      <Input
                                        className="jewelry_input jewelry_110px"
                                        placeholder={getPlaceholderForJewelry(type)}
                                        value={data.jewelry.stoneGrade || ""}
                                        onChange={(e) => handleChanges(e, "stoneGrade")}
                                        required
                                      />
                                    );
                                  } else if (type === "Other") {
                                    return (
                                      <Input
                                        className="jewelry_input jewelry_110px"
                                        placeholder={getPlaceholderForJewelry(type)}
                                        value={data.jewelry.caratValue || ""}
                                        onChange={(e) => handleChanges(e, "caratValue")}
                                        required
                                      />
                                    );
                                  } else {
                                    return (
                                      <Input
                                        className="jewelry_input jewelry_110px"
                                        placeholder="Enter Value"
                                        value={data.jewelry.genericValue || ""}
                                        onChange={(e) => handleChanges(e, "genericValue")}
                                      />
                                    );
                                  }
                                })()}
                              </td>

                              <td>
                                <div className="jewelry_select_and_input">
                                  <Select
                                    className="jewelry_select jewelry_60px"
                                    value={data.jewelry.unit || "gm"}
                                    onChange={(e, newValue) => handleChanges(newValue, "unit")}
                                    required
                                  >
                                    <Option value="gm">gm</Option>
                                    <Option value="oz">oz</Option>
                                  </Select>
                                  <Input
                                    className="jewelry_input jewelry_90px"
                                    type="number"
                                    placeholder="Weight"
                                    value={data.jewelry.weight || ""}
                                    onChange={(e) => handleChanges(e, "weight")}
                                    required
                                  />
                                </div>
                              </td>

                              <td>
                                <Input
                                  type="number"
                                  className="jewelry_input jewelry_90px"
                                  placeholder="Quantity"
                                  onChange={(e) => handleChanges(e, "quantity")}
                                  value={data.jewelry.quantity}
                                  required
                                />
                              </td>
                              <td>
                                <Input
                                  type="number"
                                  className="jewelry_input jewelry_90px"
                                  placeholder="Value"
                                  onChange={(e) =>
                                    handleChanges(e, "perQuantityValue")
                                  }
                                  value={data.jewelry.perQuantityValue}
                                  startDecorator={<div>$</div>}
                                  required
                                />
                              </td>
                              <td>
                                <Input
                                  className="jewelry_input jewelry_130px"
                                  id={`estimatedValue`}
                                  placeholder="Appraised Value"
                                  type="number"
                                  onChange={(e) => {
                                    handleChanges(e, "estimatedValue");
                                  }}
                                  value={data.jewelry.estimatedValue}
                                  startDecorator={<div>$</div>}
                                  required
                                  disabled
                                />
                              </td>
                              <td>
                                <div className="jewelry_choose_files">
                                  <div>
                                    <label
                                      className="jewelry_choose_file_label"
                                      htmlFor={`files`}
                                    >
                                      Documents
                                    </label>
                                  </div>
                                  {selectedImage?.length > 0 && (
                                    <div>
                                      <label className="jewelry_choose_images_file">
                                        {selectedImage?.length === 1
                                          ? `${
                                              selectedImage[0].name.length > 15
                                                ? selectedImage[0].name.substring(
                                                    0,
                                                    4
                                                  ) +
                                                  "..." +
                                                  selectedImage[0].name.slice(
                                                    -6
                                                  )
                                                : selectedImage[0].name
                                            }`
                                          : `${selectedImage?.length} files`}
                                      </label>
                                    </div>
                                  )}

                                  <input
                                    style={{
                                      display: "none",
                                    }}
                                    id={`files`}
                                    type="file"
                                    name="myfile"
                                    onChange={(e) => handleImageChange(e, 5)}
                                    accept=".pdf"
                                    multiple
                                  />
                                </div>
                              </td>

                              <td>
                                <div
                                  className="bene-select"
                                  onClick={handleShowBeneficiary}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  Beneficiary
                                </div>
                              </td>
                              <td>
                                <Textarea
                                  placeholder="Notes"
                                  id="notes"
                                  onChange={(e) => handleChanges(e, "notes")}
                                  value={data.jewelry.notes}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                    <CardFooter>
                      <div className="text-center">
                        <Button outline className="my-estate-add-btn">
                          Update
                        </Button>
                      </div>
                    </CardFooter>
                  </Card>
                </div>
              </container>
            </Form>
          </div>
        </div>

        {benevisible && (
          <SharedBeneficiaryEdit
            assetName={"jewelry"}
            responseData={responseData}
            responseAssetData={responseAssetData}
            handleTrustSave={handleTrustSave}
            assetData={data?.jewelry}
            trusts={trusts}
            handleChanges={handleChanges}
            sharedType={sharedType}
            handleCloseBeneficiaryPopup={handleEditCloseBeneficiary}
            estimatedTotalAmount={estimatedTotalAmount}
            typeBeneficiary={"normal"}
            sharedDetails={data?.sharedDetails}
          />
        )}
      </SideBar>
    </UserBase>
  );
}

export default EditJewelry;
